import React from "react";
import { capitalize } from "lodash";
import { Flex } from "@jsq/ds/core";
import { DetailedAchPaymentPrefObjectType } from "../../../common/types";
import PaymentDetailsModalField from "../PaymentDetailsModalField";

export type AchPaymentPrefDisplayProps = {
  achPaymentPrefFull: DetailedAchPaymentPrefObjectType;
};

export const AchPaymentPrefDisplay: React.FC<AchPaymentPrefDisplayProps> = ({
  achPaymentPrefFull,
}: AchPaymentPrefDisplayProps) => {
  const gap = 8; // gap between rows and columns
  return (
    <Flex gap={gap} flexDirection="column" data-testid="AchPaymentPrefDisplayFlex">
      <PaymentDetailsModalField
        label="Account holder name"
        value={achPaymentPrefFull.accountName}
        gap={gap}
      />
      <PaymentDetailsModalField
        label="Bank name"
        value={achPaymentPrefFull.bankName}
        gap={gap}
      />
      <PaymentDetailsModalField
        label="Routing number"
        value={achPaymentPrefFull.routingNumber}
        gap={gap}
      />
      <PaymentDetailsModalField
        label="Account number"
        value={achPaymentPrefFull.accountNumber}
        gap={gap}
      />
      <PaymentDetailsModalField
        label="Account type"
        value={achPaymentPrefFull.accountType && capitalize(achPaymentPrefFull.accountType)}
        gap={gap}
      />
      <PaymentDetailsModalField
        label="Ownership type"
        value={
          achPaymentPrefFull.accountOwnership && capitalize(achPaymentPrefFull.accountOwnership)
        }
        gap={gap}
      />
      {achPaymentPrefFull.additionalInstructions && (
        <PaymentDetailsModalField
          label="Additional instructions"
          value={achPaymentPrefFull.additionalInstructions}
          gap={gap}
        />
      )}
    </Flex>
  );
};
